import type { ColonyEvent } from './model';

type Ev = ColonyEvent;

/**
 * Zápisy jednoho včelstva. Pro každé pole zápisů se rozdělení podle včelstev
 * spočítá jen jednou (WeakMap) – přehledy pro stovky včelstev tak neprocházejí
 * všechny zápisy znovu pro každé včelstvo. Vrácené pole se nesmí měnit.
 */
const byColonyCache = new WeakMap<Ev[], Map<string, Ev[]>>();
export function colonyEvents(events: Ev[], id: string): Ev[] {
  let m = byColonyCache.get(events);
  if (!m) {
    m = new Map();
    for (const e of events) {
      if (e.deletedAt) continue;
      for (const cid of e.colonyIds) {
        const list = m.get(cid);
        if (list) list.push(e);
        else m.set(cid, [e]);
      }
    }
    byColonyCache.set(events, m);
  }
  return m.get(id) ?? [];
}
